import {configureStore} from '@reduxjs/toolkit';
import shopReducer from '../features/shop/shopSlice';
import paletteReducer from '../features/palette/paletteSlice';

const store = configureStore({
    reducer: {
        shop: shopReducer,
        palettes: paletteReducer,
    },
});

export default store;
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch